import { render, staticRenderFns } from "./CatalogueMaestro.vue?vue&type=template&id=05a074b2"
import script from "./CatalogueMaestro.vue?vue&type=script&lang=js"
export * from "./CatalogueMaestro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports